<template>
  <v-btn
    class="primary-button"
    :text="isText"
    :disabled="disabled"
    @click="
      () => {
        $emit('click');
      }
    "
  >
    {{ title }}
  </v-btn>
</template>
<script>
export default {
  props: {
    isText: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Додати",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
